module.exports = {
      id: "longform-usage",
      viewBox: "0 0 12.6 15.258",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#longform",
      toString: function () {
        return this.url;
      }
    }